import { RecordType } from '@petconsole/pure-base';
import { OurLazyLoad } from '@petconsole/pure-fe-mui';

const LazyOurPclTierPrices = (props: RecordType) => <OurLazyLoad load={() => import('./PclTierPrices')} {...props} />;
export { LazyOurPclTierPrices as PclTierPrices };
